import clsx from 'clsx';
import { ContextMenu, ContextMenuItem } from './ContextMenu';
interface GreenBoxProps {
  className?: string;
  bg?: 'dk' | 'md' | 'lt' | 'wt';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  smallText?: boolean;
  highlighted?: boolean;
  onClick?: () => void;
  contextMenuItems?: Array<ContextMenuItem>;
}

export const GreenBox = ({
  children,
  className,
  bg = 'md',
  size = 'md',
  smallText = false,
  highlighted = false,
  onClick,
  contextMenuItems,
}: React.PropsWithChildren<GreenBoxProps>) => {
  const isButton = !!onClick;

  return (
    <div
      className={clsx(
        'relative rounded-xl font-bold border-4 border-solid',
        bg === 'dk' && 'bg-pt-primary text-pt-primary-child',
        bg === 'md' && 'bg-pt-secondary-accent text-pt-secondary-accent-child',
        bg === 'lt' && 'bg-pt-secondary text-pt-secondary-child',
        bg === 'wt' && 'bg-white text-black',
        isButton &&
          bg === 'dk' &&
          !highlighted &&
          'hover:bg-pt-secondary hover:text-pt-secondary-accent',
        isButton && bg === 'md' && !highlighted && 'hover:bg-white',
        isButton && bg === 'lt' && !highlighted && 'hover:bg-secondary-accent',
        isButton &&
          bg === 'wt' &&
          !highlighted &&
          'hover:bg-secondary hover:text-secondary-accent',
        highlighted
          ? bg === 'dk' && 'border-green-normal'
          : bg === 'dk' && 'border-pt-primary',
        highlighted
          ? bg === 'md' && 'border-pt-primary'
          : bg === 'md' && 'border-green-normal',
        highlighted
          ? bg === 'lt' && 'border-pt-primary'
          : bg === 'lt' && 'border-green-light',
        highlighted
          ? bg === 'wt' && 'border-pt-primary'
          : bg === 'wt' && 'border-white',
        size === 'sm' && 'w-16 h-16 lg:w-20 lg:h-20',
        size === 'md' && 'w-28 h-28 lg:w-36 lg:h-36',
        size === 'lg' && 'w-48 h-48 lg:w-54 lg:h-54',
        size === 'xl' && 'w-72 h-72 lg:w-72 lg:h-72',
        size === 'sm' ? (smallText ? 'text-md' : 'text-2xl') : undefined,
        size === 'md' ? (smallText ? 'text-md' : 'text-4xl') : undefined,
        size === 'lg' ? (smallText ? 'text-md' : 'text-6xl') : undefined,
        size === 'xl' ? (smallText ? 'text-xl' : 'text-8xl') : undefined,
        className,
      )}
    >
      {!!onClick ? (
        <button
          className="absolute inset-0 w-full h-full flex items-center justify-center"
          onClick={onClick}
        >
          {children}
        </button>
      ) : (
        children
      )}

      {contextMenuItems && contextMenuItems.length && (
        <ContextMenu
          className="absolute top-0 right-0 font-normal"
          items={contextMenuItems}
        />
      )}
    </div>
  );
};
